// File: frontend/src/components/Dashboard/QuickActions.jsx
// Accesos rápidos del dashboard.
//
// Antes eran dos botones escondidos dentro de la tarjeta "Métricas Gerais", que
// sólo se renderizaba para dos roles: en la práctica nadie los veía. Ahora es una
// tarjeta propia, visible para todos, ocupando la columna que quedaba vacía al
// lado de "Atividades Recentes".

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  UserPlusIcon,
  CalendarDaysIcon,
  ChartPieIcon,
  BuildingOfficeIcon,
  UsersIcon,
  DocumentChartBarIcon,
} from '@heroicons/react/24/outline';

// `resource` usa el mismo gate que la navegación del Layout: no mostramos un
// atajo a una página a la que el rol no tiene acceso.
const ACTIONS = [
  { label: 'Leads', to: '/leads', resource: 'leads', icon: UserPlusIcon, tone: 'text-blue-600 bg-blue-50 dark:bg-blue-950/40' },
  { label: 'Pipeline', to: '/pipeline', resource: 'opportunities', icon: ChartPieIcon, tone: 'text-violet-600 bg-violet-50 dark:bg-violet-950/40' },
  { label: 'Atividades', to: '/activities', resource: 'activities', icon: CalendarDaysIcon, tone: 'text-emerald-600 bg-emerald-50 dark:bg-emerald-950/40' },
  { label: 'Contatos', to: '/contacts', resource: 'contacts', icon: UsersIcon, tone: 'text-indigo-600 bg-indigo-50 dark:bg-indigo-950/40' },
  { label: 'Empresas', to: '/companies', resource: 'companies', icon: BuildingOfficeIcon, tone: 'text-amber-600 bg-amber-50 dark:bg-amber-950/40' },
  { label: 'Relatórios', to: '/reports', resource: 'reports', icon: DocumentChartBarIcon, tone: 'text-rose-600 bg-rose-50 dark:bg-rose-950/40' },
];

const QuickActions = () => {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const actions = ACTIONS.filter((a) => hasPermission(a.resource, 'read'));

  if (actions.length === 0) return null;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5 h-full">
      <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">
        Ações Rápidas
      </h3>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
        Ir direto para onde o trabalho acontece
      </p>

      <div className="grid grid-cols-2 gap-2">
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <button
              key={action.to}
              type="button"
              onClick={() => navigate(action.to)}
              className="flex items-center gap-2 px-3 py-2.5 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors text-left"
            >
              <span className={`p-1.5 rounded-md flex-shrink-0 ${action.tone}`}>
                <Icon className="h-4 w-4" />
              </span>
              <span className="text-sm font-medium text-gray-700 dark:text-gray-200 truncate">
                {action.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActions;
